import { registerFr } from '../i18n/index.js';

registerFr({}, 'ConfirmModal'); // the verbs it uses live in the shared vocabulary (common.fr.ts)
